var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"label":"Client Type","outlined":_vm.outlined,"items":_vm.items,"item-text":"name","item-value":"id","clearable":_vm.clearable},on:{"change":_vm.onChange},model:{value:(_vm.selectedClientType),callback:function ($$v) {_vm.selectedClientType=$$v},expression:"selectedClientType"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12797e74","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gt/shared/ClientTypeListSelect.vue
// module id = null
// module chunks = 